// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__MAyRc","requiredAsterisk":"Info_requiredAsterisk__gHSHW"};